export const statusCodes = {
  badRequest: 400,
  conflict: 409,
  unauthorized: 401,
  unprocessable: 422,
  forbidden: 403,
  success: 200,
  notFound: 404,
  serverError: 500,
  serviceUnavailable: 503,
  networkError: 0,
  javascriptError: 1,
}
